import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { invoiceInput } from 'src/api';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Card, message, Modal} from 'antd';
import Info from './UI.Info';
import Table from './UI.Match.Table';
import Footer from './UI.Match.Footer';
import {inputSettlement} from 'src/api';
import {InvalidBtn, MatchBtn, FinishBtn,DetailBtn } from './UI.Detail.Btn';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
class Match extends UIBasic<IProps, ModulesState> {
    
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount ()  {
        ModulesAction.updateMatch(this.props.match.params.id);
    }
    
    render() {
        const {detailInfo} = this.modulesState;
        const {noticeId} = detailInfo;
        const extraButtons = (
            <div>
                {
                    this.modulesState.detailInfo.billMatchState === 'MATCHFINISH' ? 
                    <Button className="mr10" type="primary" onClick={()=>{ModulesAction.goViewMatch(noticeId);}}>
                        查看匹配详情
                    </Button> :
                    <Button 
                        className="mr10" 
                        type="primary" 
                        onClick={  async()=>{
                            await ModulesAction.handleFinish(noticeId);
                            ModulesAction.updateMatch(this.props.match.params.id);
                        }}
                    >
                        匹配完成
                    </Button>
                } 
                {
                    this.modulesState.detailInfo.billMatchState === 'MATCHFINISH' ? 
                        null :
                        <Button className="mr10" type="primary" onClick={this.handleSave}>保 存</Button>
                }
                
                <Button icon="sync" className="mr10" onClick={()=>{this.refresh();}}>刷新 </Button>
                <Button icon="left" onClick={()=>this.goBack()}>返回 </Button>
            </div>
        );
        return (
            <div className={css.right}>
                <Card title="进项结算单匹配" extra={extraButtons}>
                    <Info />
                    <Table />
                    <Footer />
                </Card>
            </div>
        );
    }
    private goBack () {
        history.go(-1);
    }
    private refresh () {
        ModulesAction.updateMatch(this.props.match.params.id);
    }
    private handleSave = async() =>{
        const data = {
            id: this.props.match.params.id,
            arr: this.modulesState.matchedInvoiceId,
        };
        const result = await inputSettlement.saveMatch(this, data);
        if (!result.er) {
            message.info('保存成功！');
        }
        this.refresh();
      
    }
    private handleFinish () {
        console.log(2223);
    }
}
export default Match;



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Match.tsx